// src/usePlacesAutocomplete.ts
import { loadPlaces } from "common/loadPlaces";
import { useEffect, useRef, useState } from "react";

export function usePlacesAutocomplete(input: string) {
  const sessionRef = useRef<google.maps.places.AutocompleteSessionToken>(null);
  const [results, setResults] = useState<
    google.maps.places.AutocompleteSuggestion[]
  >([]);

  useEffect(() => {
    loadPlaces().then(() => {
      sessionRef.current =
        new google.maps.places.AutocompleteSessionToken();
    });
  }, []);

  useEffect(() => {
    if (!input || !sessionRef.current) {
      setResults([]);
      return;
    }

    google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input,
      sessionToken: sessionRef.current,
    }).then(response => {
      setResults(response.suggestions);
    });
  }, [input]);

  return results;
}
